// Settings actions
import axios from 'axios';
import i18n from '@/i18n';
import types from '../../types';

/* eslint-disable */
export default {
  // PAYERS
  [types.GET_ADMIN_SETTINGS]: async (context, domain) => {
    try {
      if (window.location.hostname === 'localhost') return;
      await axios.get('login-settings?domain=' + domain).then((res) => {
        context.commit('STORE_ADMIN_SETTINGS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_PAYERS]: async (context) => {
    try {
      await axios.get('payer').then((res) => {
        context.commit('STORE_PAYERS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_PAYERS_OPTIONS]: async (context) => {
    try {
      await axios.get('/utilities/get-payers-options').then((res) => {
        context.commit('STORE_PAYERS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_PAYER]: async (context, payload) => {
    try {
      return await axios.post('payer', payload.form).then((r) => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('payer_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
        return r.data.data.items
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_PAYER]: async (context, payload) => {
    try {
      return await axios.put(`payer/${payload.id}`, payload.form).then((r) => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('payer_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
        return r.data.data.items
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_PAYER]: async (context, payload) => {
    try {
      await axios.delete(`payer/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_PAYER_CARRIERS]: async (context, payload) => {
    try {
      return await axios.get(`payer/${payload.id}/get-list`).then((res) => {
        context.commit('STORE_PAYER_CARRIERS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_AUTOMATION]: async (context, payload) => {
    context.commit('CLEAR_AUTOMATION');
  },
  [types.CREATE_PAYER_CARRIER]: async (context, payload) => {
    try {
      return await axios.post(`payer/${payload.payer_id}/create`, payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_PAYER_CARRIER]: async (context, payload) => {
    try {
      return await axios.post(`payer/${payload.payer_id}/update/${payload.id}`, payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_PAYER_CARRIERS]: async (context, payload) => {
    try {
      return await axios.delete(`payer/${payload.payer_id}/delete/${payload.id}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_PAYER_CARRIERS]: async (context, payload) => {
    context.commit('CLEAR_PAYER_CARRIERS');
  },
  // SENDERS
  [types.GET_SENDERS]: async (context) => {
    try {
      await axios.get('sender').then((res) => {
        context.commit('STORE_SENDERS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_SENDER]: async (context, payload) => {
    try {
      return await axios.post('sender', payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('sender_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_SENDER]: async (context, payload) => {
    try {
      await axios.put(`sender/${payload.id}`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('sender_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_SENDER]: async (context, payload) => {
    try {
      await axios.delete(`sender/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  // PRINTERS
  [types.GET_PRINTERS]: async (context) => {
    try {
      await axios.get('printer').then((res) => {
        context.commit('STORE_PRINTERS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_PRINTER]: async (context, payload) => {
    try {
      await axios.post('printer', payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('printer_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_PRINTER]: async (context, payload) => {
    try {
      await axios.put(`printer/${payload.id}`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('printer_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.TEST_PRINTER]: async (context, payload) => {
    try {
      await axios.put(`/utilities/print-test-page`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('printer_test_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_PRINTER]: async (context, payload) => {
    try {
      await axios.delete(`printer/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  //PACKAGES
  [types.GET_PACKAGES]: async (context) => {
    try {
      await axios.get(`package`).then((res) => {
        context.commit('STORE_PACKAGES', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_PACKAGE]: async (context, payload) => {
    try {
      return await axios.post('package', payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('package_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      return err;
    }
  },
  [types.EDIT_PACKAGE]: async (context, payload) => {
    try {
      await axios.put(`package/${payload.id}`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('package_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {

      console.error(err);
    }
  },
  [types.DELETE_PACKAGE]: async (context, payload) => {
    try {
      await axios.delete(`package/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  //TEAM
  [types.GET_USERS]: async (context) => {
    try {
      await axios.get(`user`).then((res) => {
        context.commit('STORE_USERS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  //Related to get_stored_user getter
  [types.GET_USER]: async (context, payload) => {
    try {
      return await axios.get(`user/${payload.id}`)
        .then((res) => {
          // Related with get_stored_user getter
        context.commit('STORE_TMP_USER', res.data.data);
        return res.data.data
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_USER]: async (context, payload) => {
    try {
      await axios.post('user', payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('team_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_USER]: async (context, payload) => {
    try {
      await axios.delete(`user/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_USER]: async (context, payload) => {
    try {
      await axios.put(`user/${payload.id}`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('team_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_OPTIONS_FOR_SELECTS_PREFERENCES]: async (context) => {
    try {
      await axios.get(`popup-data/get-options-for-preferences`).then((res) => {
        context.commit('STORE_OPTIONS_FOR_SELECTS_PREFERENCES', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_USER_PERMISSIONS]: async (context, payload) => {
    try {
      return await axios.get(`user-permissions/${payload.id}`)
        .then((res) => {
          //Only if permissions from logged user are changed we need to commit data
          if (Number(context.getters.get_user.id) === Number(payload.id)) {
            context.commit('STORE_USER_PERMISSIONS', res.data.data);
          }

          return res.data.data
        });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_USER_PERMISSIONS]: async (context, payload) => {
    try {
      await axios.put(`user-permissions/${payload.id}`, payload.form);
    } catch (err) {
      console.error(err);
    }
  },

  //WALL
  [types.GET_NEWS]: async (context) => {
    try {
      await axios.get(`wall`).then((res) => {
        context.commit('STORE_NEWS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.UPLOAD_USER_IMAGE]: async (context, payload) => {
    try {
      var formData = new FormData();
      formData.append('image', payload.file);
      formData.append('type', payload.type ? payload.type : '')
      return await axios.post(`user-image/${payload.id}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('image_successfully_uploaded'),
          type: 'success-window',
          iconName: 'check',
        });
        return res;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.REMOVE_USER_SIGNATURE]: async (context, payload) => {
    try {
      await axios.put(`user-image/${payload.id}/delete-signature`, payload.form).then((res) => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('signature_successfully_deleted'),
          type: 'success-window',
          iconName: 'check',
        });
        return res;
      });
    } catch (err) {
      console.error(err);
    }
  },
  //SMTP
  [types.GET_SMTPS]: async (context) => {
    try {
      await axios.get(`smtp`).then((res) => {
        context.commit('STORE_SMTP', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_SMTP]: async (context, payload) => {
    try {
      await axios.post('smtp', payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('smtp_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_SMTP]: async (context, payload) => {
    try {
      await axios.put(`smtp/${payload.id}`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('smtp_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_SMTP]: async (context, payload) => {
    try {
      await axios.delete(`smtp/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_ALL_SMTPS]: async (context) => {
    try {
      await axios.get('utilities/get-all-smtps').then((res) => {
        context.commit('STORE_ALL_SMTPS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  //UPLOAD-TEMPLATE
  [types.CREATE_TEMPLATE]: async (context, payload) => {
    try {
      return await axios.post('upload-template', payload).then((res) => {
        return res.data;
      });
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  [types.GET_TEMPLATES]: async (context) => {
    try {
      await axios.get(`upload-template`).then((res) => {
        context.commit('STORE_TEMPLATES', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_TEMPLATE_BY_ID]: async (context, payload) => {
    try {
      return await axios.get(`upload-template/${payload}`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_TEMPLATE]: async (context, payload) => {
    try {
      await axios.post('upload-template', payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_TEMPLATE]: async (context, payload) => {
    try {
      await axios.put(`upload-template/${payload.id}`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('template_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_TEMPLATE_BY_ID]: async (context, payload) => {
    try {
      return await axios.delete(`upload-template/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.UPLOAD_TEMPLATE]: async (context, payload) => {
    try {
      var formData = new FormData();
      formData.append('file', payload.file);
      return await axios.post(`admin-upload/upload/${payload.id}?subaccount_id=${payload.subaccountId}`, formData, {
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            context.commit('STORE_UPLOAD_PROGRESS', percentCompleted);
          },
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      }).then((res) => {
        return res;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.TRACK_VALIDATION_PROGRESS]: async (context, payload) => {
    try {
      return await axios.get(`progress-track/${payload}`).then((res) => res);
    } catch (err) {
      console.error(err);
    }
  },
  [types.VALIDATE_ERRORS]: async (context, payload) => {
    try {
      return await axios.get(`error-report/get-errors?table=admin_upload_queue&item_id=${payload}`).then((res) => res);
    } catch (err) {
      console.error(err);
    }
  },
  [types.START_TEMPLATE_IMPORT]: async (context, payload) => {
    try {
      axios.get(`admin-upload/import/${payload.templateId}?import_id=${payload.importId}`)
      .then((res) => {
        context.dispatch('STORE_IN_QUEUE', {
          progressId: res.data.data.progress_id,
          fileName: payload.fileName,
          iconName: payload.iconName,
          templateType: payload.templateType,
          progressStatus: 0,
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  //SYSTEM
  [types.GET_SYSTEMS]: async (context) => {
    try {
      return await axios.get('system').then((res) => {
        context.commit('STORE_SYSTEM', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_SYSTEM]: async (context, payload) => {
    try {
      return await axios.post('system', payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('system_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  //CARRIER-ACCOUNTS
  [types.GET_CARRIER_ACCOUNTS]: async (context) => {
    try {
      return await axios.get('account').then((res) => {
        context.commit('STORE_CARRIER_ACCOUNTS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_CARRIER_ACCOUNTS_BY_COMPANY]: async (context) => {
    try {
      return await axios.get('account-action/get-by-company').then((res) => {
        context.commit('STORE_CARRIER_ACCOUNTS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_CARRIER_ACCOUNT]: async (context, payload) => {
    try {
      return await axios.get(`account/${payload.id}`)
        .then((res) => {
          context.commit('STORE_CARRIER_ACCOUNT', res.data.data);
          return res.data.data;
        });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_CARRIER_ACCOUNT]: async (context, payload) => {
    try {
      return await axios.post('account', payload).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('carrier_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_CARRIER_ACCOUNT]: async (context, payload) => {
    try {
      await axios.put(`account/${payload.id}`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('carrier_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_CARRIER_ACCOUNT_BY_ID]: async (context, payload) => {
    try {
      return await axios.delete(`account/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_SHIPPING_AGENTS]: async (context) => {
    try {
      return await axios.get('shipping-agent').then((res) => {
        context.commit('STORE_SHIPPING_AGENTS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_COMPANY_AVAILABLE_SHIPPING_AGENTS]: async (context) => {
    try {
      return await axios.get('popup-data/get-available-shipping-agents').then((res) => {
        context.commit('STORE_COMPANY_AVAILABLE_SHIPPING_AGENTS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_INTEGRATION_BY_CARRIER]: async (context, payload) => {
    try {
      return await axios.get(`popup-data/get-integrations-by-agent?shipping_agent_id=${payload}`).then((res) => {
        context.commit('STORE_INTEGRATION_BY_CARRIER', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_INTEGRATION_PARAMS]: async (context, payload) => {
    try {
      return await axios.get(`popup-data/get-carrier-integration-params?shipping_agent_id=${payload.agentID}&integration_id=${payload.integrationID}`).then((res) => {
        context.commit('STORE_INTEGRATION_PARAMS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_INTEGRATION_PARAMS]: async (context) => {
    context.commit('CLEAR_INTEGRATION_PARAMS');
  },
  [types.GET_CARRIER_ACCOUNT_PRODUCT_BY_ID]: async (context, payload) => {
    try {
      return await axios.get(`carrier-account-product/${payload}/get-by-id`).then((res) => {
        context.commit('STORE_CARRIER_ACCOUNT_PRODUCTS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_CARRIER_ACCOUNT_PRODUCTS]: async (context, payload) => {
    try {
      return await axios.get(`carrier-account-product/${payload}/get`).then((res) => {
        context.commit('STORE_CARRIER_ACCOUNT_PRODUCTS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_CARRIER_ACCOUNT_PRODUCTS]: async (context, payload) => {
    try {
      return await axios.post('carrier-account-product/create', {
        shipping_product_id: payload.shipping_product_id,
        admin_carrier_account_id: payload.admin_carrier_account_id,
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_CARRIER_ACCOUNT_PRODUCTS]: async (context, payload) => {
    try {
      return await axios.put(`carrier-account-product/${payload.id}/update`, payload.payload);
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_CARRIER_ACCOUNT_PRODUCTS]: async (context, payload) => {
    try {
      return await axios.delete(`carrier-account-product/${payload}/delete`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_SHIPPING_PRODUCTS]: async (context, payload) => {
    try {
      let uri = `popup-data/get-shipping-products?shipping_agent_id=${payload.agentId}`;

      if ('type' in payload) {
        uri = uri.concat(`&type=${payload.type}`);
      }

      if ('category' in payload) {
        uri = uri.concat(`&category_type=${payload.category}`);
      }

      return await axios.get(uri).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  //NOTIFICATIONS
  [types.GET_NOTIFICATIONS]: async (context) => {
    try {
      return await axios.get('message/get-list').then((res) => {
        context.commit('STORE_NOTIFICATIONS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_NOTIFICATION]: async (context, payload) => {
    try {
      return await axios.get(`message/get/${payload}`)
        .then((res) => {
          context.commit('STORE_NOTIFICATION', res.data.data);
          return res.data.data
        });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_NOTIFICATION]: async (context, payload) => {
    try {
      return await axios.post('message/create-message', payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('notification_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_NOTIFICATION]: async (context, payload) => {
    try {
      return await axios.put(`message/customize-message/${payload.id}`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('notification_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_NOTIFICATION]: async (context, payload) => {
    try {
      return await axios.delete(`message/delete/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },
  //AUTOMATIONS
  [types.GET_AUTOMATIONS]: async (context) => {
    try {
      return await axios.get('automation').then((res) => {
        context.commit('STORE_AUTOMATIONS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_AUTOMATION]: async (context, payload) => {
    try {
      return await axios.get(`automation/${payload}`)
        .then((res) => {
          context.commit('STORE_AUTOMATION', res.data.data);
          return res.data.data
        });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_AUTOMATION]: async (context, payload) => {
    try {
      return await axios.post('automation', payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_AUTOMATION]: async (context, payload) => {
    try {
      return await axios.put(`automation/${payload.id}`, payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_AUTOMATION]: async (context, payload) => {
    try {
      return await axios.delete(`automation/${payload.id}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_AUTOMATION_ACTIONS]: async (context, payload) => {
    try {
      return await axios.get(`automation/${payload.id}/get-list`).then((res) => {
        context.commit('STORE_AUTOMATION_ACTIONS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_AUTOMATION]: async (context, payload) => {
    context.commit('CLEAR_AUTOMATION');
  },
  [types.CREATE_AUTOMATION_ACTION]: async (context, payload) => {
    try {
      return await axios.post(`automation/${payload.automation_id}/create`, payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_AUTOMATION_ACTION]: async (context, payload) => {
    try {
      return await axios.post(`automation/${payload.automation_id}/update/${payload.id}`, payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_AUTOMATION_ACTIONS]: async (context, payload) => {
    try {
      return await axios.delete(`automation/${payload.automation_id}/delete/${payload.id}`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_AUTOMATION_ACTIONS]: async (context, payload) => {
    context.commit('CLEAR_AUTOMATION_ACTIONS');
  },
  [types.GET_ALL_PACKAGING_OPTIONS]: async (context) => {
    try {
      return await axios.get('utilities/get-all-packaging-options?with_pallet=1').then((res) => {
        context.commit(types.STORE_ALL_PACKAGING_OPTIONS, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
//ACCOUNT CONSIGNOR
  [types.GET_ACCOUNT_CONSIGNORS]: async (context) => {
    try {
      return await axios.get('account-consignor').then((res) => {
        context.commit('STORE_ACCOUNT_CONSIGNORS', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_ACCOUNT_CONSIGNOR]: async (context, payload) => {
    try {
      return await axios.get(`account-consignor/${payload}`)
        .then((res) => {
          context.commit('STORE_ACCOUNT_CONSIGNORS', res.data.data);
          return res.data.data
        });
    } catch (err) {
      console.error(err);
    }
  },
  [types.SET_ACCOUNT_CONSIGNOR]: async (context, payload) => {
    try {
      return await axios.post('account-consignor', payload);
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_ACCOUNT_CONSIGNOR]: async (context, payload) => {
    try {
      return await axios.put(`account-consignor/${payload.id}`, payload.form);
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_ACCOUNT_CONSIGNOR]: async (context, payload) => {
    try {
      return await axios.delete(`account-consignor/${payload}`);
    } catch (err) {
      console.error(err);
    }
  },

  //DANSKE CODE MAPPING
  [types.GET_ACCOUNT_DANSKE_CODES]: async (context, payload) => {
    try {
      return await axios.get(`account/${payload.account_id}/danske-code/get-list`).then((res) => {
        context.commit(types.STORE_ACCOUNT_DANSKE_CODES, res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_ACCOUNT_DANSKE_CODE]: async (context, payload) => {
    try {
      return await axios.get(`account/${payload.account_id}/danske-code/${payload.id}/get`)
        .then((res) => {
        //  context.commit(types, res.data.data);
          return res.data.data
        });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_ACCOUNT_DANSKE_CODE]: (context, payload) => {
    try {
      return axios.put(`account/${payload.account_id}/danske-code/${payload.id}/update`, payload.data);
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_ACCOUNT_DANSKE_CONFIGURATIONS]: (context, payload) => {
    try {
      return axios.put(`account/${payload}/danske-code/get-configurations`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_FTP_SETTINGS]: async (context) => {
    try {
      await axios.get(`ftp-settings`).then((res) => {
        context.commit('STORE_FTP_SETTINGS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
};
